import React from 'react'
import { Linking } from 'react-native'
import styled from 'styled-components/native'
import { colors } from '@lib/colors'

interface LinkProps {
  uri: string
}

const LinkText = styled.Text`
  color: ${colors.blue[500]};
  text-align: center;
`

const Link: React.FC<LinkProps> = (props) => {
  const { children, uri } = props

  return (
    <LinkText onPress={() => Linking.openURL(uri)}>
      { children }
    </LinkText>
  )
}

export default Link
